<div class="animal-list">
  <div class="animal-grid animal-grid--header">
    <div class="cell cell--image"></div>
    <div class="cell">
      {{ 'dashboard.newAnimals.name' | transloco }}
    </div>
    <div class="cell">
      {{ 'dashboard.newAnimals.bookNumber' | transloco }}
    </div>
    <div class="cell">
      {{ 'dashboard.newAnimals.birthday' | transloco }}
    </div>
    <div class="cell">
      {{ 'dashboard.newAnimals.transponderNumber' | transloco }}
    </div>
    <div class="cell">
      {{ 'dashboard.newAnimals.origin' | transloco }}
    </div>
    <div class="cell">
      {{ 'dashboard.newAnimals.whereabout' | transloco }}
    </div>
  </div>

  <div class="animal-list__body">
    @for (animal of pagedAnimals; track animal.id) {
    <div
      class="animal-grid animal-grid--row"
      (click)="onRowClick(animal, $event)"
    >
      <div class="cell cell--image flex items-center justify-center">
        <div class="relative w-[100px] h-[100px]">
          <app-animal-image-container
            [animal]="animal"
            [preview]="true"
          ></app-animal-image-container>
        </div>
      </div>
      <div class="cell flex items-center">
        {{ animal?.displayName }}
      </div>
      <div class="cell flex items-center">
        <div>
          {{getLastOldBookNumber(animal)}} ({{ animal?.bookNumber || '-' }})
        </div>
      </div>
      <div class="cell flex items-center">
        <div class="cell flex items-center">
          @let b = getBirthDisplay(animal); @if (b.text !== '-') {
          {{ b.text }}
          @if (b.age !== null) { &nbsp; ({{ b.age }}
          {{ 'animalAdd.general.specifications.year' | transloco }}) } } @else {
          - }
        </div>
      </div>
      <div class="cell flex items-center">
        {{ animal.transponderNumber || '-' }}
      </div>
      <div class="cell flex items-center">
        @let origin = getOrigin(animal.id); @let originLoading =
        isOriginLoading(animal.id); @if (originLoading) {
        <p-skeleton width="100%" height="1rem"></p-skeleton>
        } @else if (origin && (origin.type || origin.location ||
        origin.dateOfReceipt)) {
        <span>
          @if (origin.type) {
          {{ 'animalOrigin.types.' + origin.type | transloco }}
          } @if (origin.location) { @if (origin.type) { | }
          {{ origin.location }}
          } @if (origin.dateOfReceipt) { @if (origin.type ||
          origin.location) { | }
          {{ origin.dateOfReceipt | date : 'dd.MM.yyyy' }}
          }
        </span>
        } @else { - }
      </div>
      <div class="cell flex items-center">
        @let wb = getWhereabout(animal.id); @let wbLoading =
        isWhereaboutLoading(animal.id);
        @if (wbLoading) {
          <p-skeleton width="100%" height="1rem"></p-skeleton>
        } @else if (!animal.inStock && wb && wb?.type) {
          <span>
            {{ 'animalWhereabout.type.' + wb.type | transloco }}
            @if (wb.type && (wb.location || wb.date)) {
             |
            }
            @if (wb.location) {
              {{ wb.location }}
            }
            @if (wb.location && wb.date) {
             |
            }
            @if (wb.date) {
              {{ wb.date | date : getDateFormat() }}
            }
            @if (wb.contact && !hideDetails) {
            <p-button
              [routerLink]="['/kontakte', wb.contact.id]"
              icon="pi pi-eye"
              [text]="true"
              [rounded]="true"
              [raised]="true"
            />
            }
          </span>
        } @else { - }
      </div>
      <div class="animal-grid__labels col-span-full">
        <app-animal-labels [animal]="animal"></app-animal-labels>
      </div>
    </div>
    }
  </div>

  <p-paginator
    *ngIf="pageable"
    styleClass="mt-2"
    [rows]="pageSize"
    [totalRecords]="totalRecords ?? animals.length"
    [first]="currentPage * pageSize"
    (onPageChange)="onPageChange($event)"
  ></p-paginator>
</div>
